import { authFetch } from "@/api/authFetch.ts"
import { API_BASE } from "@/config.ts"

import type { Driver } from "../types/logisticsTypes.ts"

export const getDrivers = async () => {
  const res = await authFetch(`${API_BASE}/logistics/drivers?companyId=4`)
  const data: Driver[] = await res.json()

  return data
}
